export default __webpack_public_path__ + "static/media/BG_Page_01.cdde7fb1.svg";